module.exports = __webpack_public_path__ + "img/icon_video_outlined_w.4f011047.svg";